module.exports = __webpack_public_path__ + "static/media/slide1.94fa94b0.png";